import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { EstensioneService } from 'src/app/services/estensione.service';
import { ToastrService } from 'ngx-toastr';
import { extensions } from '../config';
import { Estensione } from 'src/app/models/estensione';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from 'src/app/services/api-config';
import { CompagniaService } from 'src/app/services/compagnia.service';
import { StatoIncaricoService } from 'src/app/services/stato-incarico.service';

@Component({
  selector: 'app-integrazione-unipol',
  templateUrl: './integrazione-unipol.component.html',
  styleUrls: ['./integrazione-unipol.component.scss']
})
export class IntegrazioneUnipolComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private toast: ToastrService,
    private http: HttpClient,
    private compagniaService: CompagniaService,
    private statoIncaricoService: StatoIncaricoService,
  ) { }

  slug: string = 'Unipol';
  form: FormGroup;
  loggedInUser: User;
  params: any;
  extension: Estensione;
  certificateUploaded: boolean = false;
  uploading: boolean = false;

  certFile: File | null = null;
  keyFile: File | null = null;

  async ngOnInit(): Promise<any> {
    this.loggedInUser = this.authService.loggedInUser.getValue();

    this.form = this.fb.group({
      client_id: '',
      client_secret: '',
      partita_iva: '',
      environment: 'test',
      compagnia: '',
      statoDefault: '',
      enabled: false,
    });

    try {
      this.extension = await this.estensioneService.bySlug(extensions.unipol);
      if (this.extension && this.extension.id) {
        this.form.patchValue({
          client_id: this.extension.configuration?.client_id || '',
          client_secret: this.extension.configuration?.client_secret || '',
          partita_iva: this.extension.configuration?.partita_iva || '',
          environment: this.extension.configuration?.environment || 'test',
          enabled: this.extension.enabled,
        });
        this.certificateUploaded = this.extension.configuration?.certificate_uploaded || false;

        await this.patchCompagniaControl(this.extension.configuration?.compagnia_id);
        await this.patchStatoDefault(this.extension.configuration?.default_stato_id);
      }

      // Check certificate status
      await this.checkCertificateStatus();
    } catch (e) {
      console.error(e);
    }
  }

  private async patchCompagniaControl(compagniaId?: number | string | null) {
    if (!compagniaId) return;
    try {
      const comp = await this.compagniaService.getOne(compagniaId as number);
      this.form.patchValue({
        compagnia: comp ? { id: comp.id, humanIdentifier: comp.nome, nome: comp.nome } : compagniaId,
      });
    } catch (err) {
      console.error(err);
      this.form.patchValue({ compagnia: compagniaId });
    }
  }

  private async patchStatoDefault(statoId?: number | string | null) {
    if (!statoId) return;
    try {
      const stato = await this.statoIncaricoService.getOne(statoId as number);
      this.form.patchValue({
        statoDefault: {
          id: stato.id,
          humanIdentifier: stato.humanIdentifier ?? stato.nome ?? stato.id
        }
      });
    } catch (err) {
      console.error(err);
      this.form.patchValue({ statoDefault: statoId });
    }
  }

  async checkCertificateStatus(): Promise<void> {
    try {
      const response: any = await this.http.get(`${baseUrl}/estensioni/unipol/certificate-status`).toPromise();
      this.certificateUploaded = response.certificate_uploaded || false;
    } catch (e) {
      console.error('Error checking certificate status', e);
    }
  }

  onCertFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.certFile = input.files[0];
    }
  }

  onKeyFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.keyFile = input.files[0];
    }
  }

  async uploadCertificates(): Promise<void> {
    if (!this.certFile || !this.keyFile) {
      this.toast.warning('Seleziona entrambi i file: certificato (.crt) e chiave (.key)');
      return;
    }

    this.uploading = true;

    const formData = new FormData();
    formData.append('cert_file', this.certFile);
    formData.append('key_file', this.keyFile);

    try {
      const response: any = await this.http.post(`${baseUrl}/estensioni/unipol/upload-certificate`, formData).toPromise();
      this.certificateUploaded = response.certificate_uploaded || true;
      this.toast.success('Certificati caricati con successo');
      this.certFile = null;
      this.keyFile = null;
    } catch (e: any) {
      console.error('Error uploading certificates', e);
      this.toast.error(e.error?.message || 'Errore durante il caricamento dei certificati');
    } finally {
      this.uploading = false;
    }
  }

  async deleteCertificates(): Promise<void> {
    if (!confirm('Sei sicuro di voler eliminare i certificati?')) {
      return;
    }

    try {
      await this.http.delete(`${baseUrl}/estensioni/unipol/delete-certificate`).toPromise();
      this.certificateUploaded = false;
      this.toast.success('Certificati eliminati');
    } catch (e: any) {
      console.error('Error deleting certificates', e);
      this.toast.error(e.error?.message || 'Errore durante l\'eliminazione dei certificati');
    }
  }

  async Salva(): Promise<void> {
    const conf = JSON.stringify({
      client_id: this.form?.value.client_id,
      client_secret: this.form?.value.client_secret,
      partita_iva: this.form?.value.partita_iva,
      environment: this.form?.value.environment,
      certificate_uploaded: this.certificateUploaded,
      compagnia_id: this.form?.value.compagnia?.id ?? this.form?.value.compagnia ?? null,
      default_stato_id: this.form?.value.statoDefault?.id ?? this.form?.value.statoDefault ?? null,
    });

    this.params = {
      slug: extensions.unipol,
      configuration: conf,
      enabled: this.form?.value.enabled ? this.form.value.enabled : false,
      studio_id: this.loggedInUser.studio_id
    };

    const res = await this.estensioneService.saveOrUpdate(this.params, this.slug);

    if (res.created && res.updated) {
      this.toast.error('Errore nel server');
      return;
    }

    if (res.created) {
      this.toast.success('Configurazione creata');
      return;
    }

    if (res.updated) {
      this.toast.success('Configurazione salvata');
      return;
    }
  }
}
